import React from "react";
import { History } from "lucide-react";
import { fmtDateTime } from "./PolicyBadges";

const describe = (e) => {
  const d = e.details || {};
  if (d.from && d.to) return `${d.from} → ${d.to}${d.note ? ` — "${d.note}"` : ""}`;
  if (d.version_label) return `${d.version_label}${d.file_name ? ` · ${d.file_name}` : ""}${d.extraction_status ? ` · extraction ${d.extraction_status}` : ""}`;
  const keys = Object.keys(d);
  if (keys.length && typeof d[keys[0]] === "object" && d[keys[0]] !== null && "to" in d[keys[0]]) return keys.map((k) => `${k}: ${JSON.stringify(d[k].from)} → ${JSON.stringify(d[k].to)}`).join("; ");
  return keys.length ? JSON.stringify(d) : "";
};

export const PolicyAuditTrail = ({ events }) => (
  <div className="nv-card p-5" data-testid="policy-audit-trail">
    <h3 className="text-h3 flex items-center gap-2"><History size={16} /> Audit trail <span className="text-xs font-normal text-slate-400">{events.length} events</span></h3>
    <ol className="mt-3 space-y-2 max-h-80 overflow-y-auto">
      {events.map((e) => (
        <li key={e.id} className="text-xs border-l-2 border-slate-200 pl-3 py-0.5" data-testid={`audit-event-${e.id}`}>
          <p className="text-slate-800"><b>{e.action}</b> · {e.actor_name} <span className="text-slate-400">({e.actor_role})</span></p>
          <p className="text-slate-500">{fmtDateTime(e.at)}{describe(e) ? ` · ${describe(e)}` : ""}</p>
        </li>
      ))}
      {!events.length && <li className="text-xs text-slate-500">No events yet.</li>}
    </ol>
  </div>
);
